import React from 'react'

export const Warning = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g clip-path="url(#clip0_5538_6838)">
      <path d="M13.299 3.14746L21.933 18.102C22.5103 19.102 21.7887 20.352 20.634 20.352H3.36601C2.21131 20.352 1.48962 19.102 2.06697 18.102L10.7009 3.14747C11.2783 2.14747 12.7217 2.14746 13.299 3.14746ZM12 14.9998C11.4477 14.9998 11 15.4475 11 15.9998C11 16.5521 11.4477 16.9998 12 16.9998C12.5523 16.9998 13 16.5521 13 15.9998C13 15.4475 12.5523 14.9998 12 14.9998ZM12 7.99976C11.4871 7.99976 11.0645 8.3858 11.0067 8.88314L11 8.99976V12.9998C11 13.5521 11.4477 13.9998 12 13.9998C12.5128 13.9998 12.9355 13.6137 12.9933 13.1164L13 12.9998V8.99976C13 8.44748 12.5523 7.99976 12 7.99976Z" fill="#FF4F00" />
    </g>
    <defs>
      <clipPath id="clip0_5538_6838">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
